function officeCityStateLine(o) {
  if (!o) {
    return '';
  }
  return [o.city, o.state].filter(Boolean).join(', ');
}

function practiceDefaultOffice(practice) {
  return practice?.get('defaultOffice') ?? null;
}

function practiceDefaultCityStateLine(practice) {
  return officeCityStateLine(practiceDefaultOffice(practice));
}

function modalityLabel({ hasInPerson, hasTelehealth, inPersonCount, intl, k }) {
  if (!hasInPerson && !hasTelehealth) {
    return '';
  }

  let base = hasInPerson && hasTelehealth ? 'hybrid' : hasInPerson ? 'remote' : 'virtualOnly';
  let extra = Math.max(0, (inPersonCount ?? 1) - 1);

  if (hasInPerson && extra > 0) {
    return intl.t(`${k}${base}ExtraLocations`, { extra });
  }
  return intl.t(`${k}${base}`);
}

function isPhysicalOffice(office) {
  return !!office && !office.isVideo;
}

function isVideoOffice(office) {
  return !!office && !!office.isVideo;
}

function labelPhysicalOffice({ availableOffices, dominantOffice }) {
  let physical = (availableOffices ?? []).filter(isPhysicalOffice);
  if (physical.length) {
    // Prefer the dominant office when it survived filtering, else the first.
    return physical.find(o => String(o.id) === String(dominantOffice?.id)) ?? physical[0];
  }
  return dominantOffice && isPhysicalOffice(dominantOffice) ? dominantOffice : null;
}

// Modality is derived only from the clinician's resolved offices under the
// active filters. When none resolve we cannot determine modality.
export function officeModalityFlags({ availableOffices }) {
  let offices = (availableOffices ?? []).filter(Boolean);
  return {
    hasInPerson: offices.some(isPhysicalOffice),
    hasTelehealth: offices.some(isVideoOffice),
  };
}

export function locationLineFor({ dominantOffice, availableOffices, practice, intl }) {
  let k = 'booking.clinicianSearch.card.';
  let selectedPhysicalOffice = labelPhysicalOffice({ availableOffices, dominantOffice });

  let left = selectedPhysicalOffice
    ? officeCityStateLine(selectedPhysicalOffice)
    : practiceDefaultCityStateLine(practice);

  let { hasInPerson, hasTelehealth } = officeModalityFlags({ availableOffices });
  let physicalCount = (availableOffices ?? []).filter(isPhysicalOffice).length;
  let right = modalityLabel({ hasInPerson, hasTelehealth, inPersonCount: physicalCount, intl, k });
  if (left && right) {
    return `${left} | ${right}`;
  }
  return left || right;
}
